import React from 'react';
import { useTranslation } from 'react-i18next';

import {
  convertCurrency,
  getPremiumStyled,
  RETURN_VALUE_ONLY,
} from 'enrollment/utils';
import { CoverageLineDto } from 'enrollment/queries/useBenefitPlansQuery/types';
import {
  MaxSliderValueContainer,
  StackedVolumeReviewContainer,
} from 'enrollment/features/Plans/PlanCard/StackedVolume';

interface CoverageAmountProps {
  amount: string;
  stackedCoverageLines?: CoverageLineDto[];
}

export const CoverageAmount: React.FC<CoverageAmountProps> = ({
  amount,
  stackedCoverageLines,
}) => {
  const { t } = useTranslation('pages.enrollment.review');

  // Convert the amount to a number and format it
  const formattedAmount = getPremiumStyled({
    premium: amount,
    valueOnly: RETURN_VALUE_ONLY,
  });
  return (
    <>
      <div className="coverage-amount">
        {t('coverageAmt')}: <span>{formattedAmount}</span>
      </div>
      {stackedCoverageLines && stackedCoverageLines.length > 0 && (
        <StackedVolumeReviewContainer className="py-2 mt-2">
          {stackedCoverageLines.map((line, index) => (
            <MaxSliderValueContainer>
              <div className="d-flex align-items-center px-3">
                <p className="body2 pr-3">
                  {t('policyLine')} {index + 1}:
                </p>
                <p className="body2 semiBold">
                  {convertCurrency(line.req_volume)}
                </p>
              </div>
              <div className="d-flex align-items-center px-3">
                <p className="body1 semiBold">
                  {convertCurrency(line.req_subscriber_premium)}
                </p>
              </div>
            </MaxSliderValueContainer>
          ))}
        </StackedVolumeReviewContainer>
      )}
    </>
  );
};
